module.exports = __webpack_public_path__ + "img/06.27505ef7.png";